import React, { Fragment, useState, useEffect } from 'react';
import { Link, useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData, postData, fetchDataActive, fetchDatalist, fetchDataAccountsIncomeExpense, fetchData1, updateDataNew, postDataNew, deleteIncomeExpenseData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { IconButton, Modal, Button, TextField, MenuItem } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import Select from 'react-select';
import Box from '@mui/material/Box';
import {
  Search as SearchIcon,

  Edit as EditIcon,
  Delete as DeleteIcon
} from '@mui/icons-material';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import { TableCell, TableContainer, Tooltip, Paper, Table, TablePagination, TableHead, TableBody, TableRow } from '@mui/material';

const EventEdit = () => {

  const history = useHistory();
  const [searchTerm, setSearchTerm] = useState('');
  const { isAuthenticated, clubId, branchId, userId, logout, token } = useAuth();
  const [eventname, setEventName] = useState("");
  const [fromdate, setFromDate] = useState("");
  const [todate, setToDate] = useState("");
  const [description, setDescription] = useState("");
  const [description1, setDescription1] = useState("");
  const [venue, setVenue] = useState("");
  const [incomeestimate, setIncomeEstimate] = useState("");
  const [expenseestimate, setExpenseEstimate] = useState("");
  const [incomeactual, setIncomeActual] = useState("");
  const [expenseactual, setExpenseActual] = useState("");
  const [membertype, setMemberType] = useState(0);
  const [isSubmit, setIsSubmit] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isSave, setIsSave] = useState(false);
  const [memberlist, setMemberOptions] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [selectedMemberlist, setSelectedMemberList] = useState([]);
  const [selectedMembers, setSelectedMembers] = useState({});
  const [selectedFamilyMembers, setSelectedFamilyMembers] = useState([]); // Store selected family members
  const [familyMembers, setFamilyMembers] = useState([]); // Store fetched family members
  const [selectedMember, setSelectedMember] = useState(""); // Store selected member ID
  const [data, setData] = useState([]);
  const [isIdValid, setIsIdValid] = useState(true);
  const [participantsData, setParticipantsData] = useState([]);
  const [incomeexpenseList, setIncomeAndExpenseList] = useState([]);
  const { id } = useParams();
  const [editMode, setEditMode] = useState(null); // Track the participant being edited
  const [editedPhone, setEditedPhone] = useState('');
  const [isincome, setIncome] = useState(false);
  const [isExpense, setExpense] = useState(true);
  const [isFocused, setIsFocused] = useState(false);
  const [filterparticipantsData, setFilterParticipantsData] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [IsPaymentandReceipt, setIsPaymentandReceipt] = useState('');
  //payment and receipt
  const [paymentType, setPaymentType] = useState('0');
  const [ispayment, setIsPayment] = useState(true);
  const [billNo, setBillNo] = useState("");
  const [clubIncomeExpenseOption, setClubIncomeExpenseOption] = useState(null);
  const [amount, setAmount] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  const [chequeNo, setChequeNo] = useState("");
  const [chequeDate, setChequeDate] = useState("");
  const [bankId, setBankId] = useState("");
  const [banklist, setBankOptions] = useState([]);
  const [selectedbank, setSelectedBank] = useState("");
  const [eventIncomeExpenseOption, setEventIncomeExpenseOption] = useState(null);
  const [incomeList, setIncomeList] = useState([]);
  const [expenseList, setExpenseList] = useState([]);
  const [incomeSplitList, setIncomeSplitList] = useState([]);
  const [expenseSplitList, setExpenseSplitList] = useState([]);
  const [incomeActualSplit, setincomeActualSplit] = useState(false);
  const [expenseActualSplit, setexpenseActualSplit] = useState(false);
  const [searchMember, setSearchMember] = useState('');
  const today = new Date().toISOString().split("T")[0];
  const [billDate, setBillDate] = useState(today);
  const [eventheadincomelist, setEventHeadIncomeOptions] = useState([]);
  const [eventheadexpenselist, setEventHeadExpenseOptions] = useState([]);
  const [selectedgroup, setselectedgroup] = useState("");
  const [isSubmit1, setIsSubmit1] = useState(false);
  const [parentGroupOptions, setParentGroupOptions] = useState([]);
  const [eventIncomeExpenseselectedOption1, setEventIncomeExpenseSelectedOption] = useState(null);
  const [eventIncomeExpenseoptions, setEventIncomeExpenseOption1] = useState(null);

  const [isModalOpenCreateHead, setIsModalOpenCreateHead] = useState(false);
  const [ispersonModalOpen, setPersonModalOpen] = useState(false);
  const [memberid, setMemberId] = useState("");
  const [natureOptions, setNatureOptions] = useState([]);
  const [parent, setParent] = useState();
  useEffect(() => {
    if (isAuthenticated && tokenIsExpired(token)) {

      logout();
      return;
    }

    fetchtableData();

    if (id) {
      fetchData('EventApi', `/GetEventDetails/${id}`, token)
        .then((response) => {
          if (response.responseCode === '1111') {
            console.log('Full API Response:', response.response_data); // Log the full response

            // Destructure response data with fallbacks
            const EventdatasDatas = response.response_data.eventMasterData || {};
            const participantsDatas = response.response_data.eventParticipantsData || [];
            const incomeExpenseData = response.response_data.eventIncomeAndExpenseData || [];

            // Ensure incomeExpenseData is an array
            const validatedIncomeExpenseData = Array.isArray(incomeExpenseData) ? incomeExpenseData : [];

            // Set form data
            setFormData({
              ...EventdatasDatas,
              UpdatedBy: userId,
            });

            // Set the incomeExpenseList
            setIncomeAndExpenseList(validatedIncomeExpenseData); // Set as array

            // Calculate initial estimates
            const totalIncome = validatedIncomeExpenseData
              .filter(record => record.isIncome)
              .reduce((total, record) => total + record.amount, 0);
            setIncomeEstimate(totalIncome);

            const totalExpense = validatedIncomeExpenseData
              .filter(record => !record.isIncome)
              .reduce((total, record) => total + record.amount, 0);
            setExpenseEstimate(totalExpense);
            const filteredParticipants = "";




            const incomeList = incomeExpenseData.filter(item => item.isIncome); // Filter income
            const expenseList = incomeExpenseData.filter(item => !item.isIncome); // Filter expenses

            const incomeExpenseData1 = incomeList.map(incomeexpense => ({
              value: incomeexpense.id,
              label: incomeexpense.description
              ,
            }));

            const incomeExpenseData2 = expenseList.map(incomeexpense => ({
              value: incomeexpense.id,
              label: incomeexpense.description
              ,
            }));
            // Set both income and expense lists
            fetchBank();

            setIncomeList(incomeExpenseData1);
            setExpenseList(incomeExpenseData2);
            // Validate and set participants data
            if (Array.isArray(participantsDatas)) {
              setParticipantsData(participantsDatas);
              setFilterParticipantsData(participantsDatas);

            } else {
              console.error('Expected an array for participantsDatas but got:', participantsDatas);
              setParticipantsData([]); // Fallback to empty array
              setFilterParticipantsData([]);

            }
          } else {
            setIsIdValid(false);
            setErrorMessage('Invalid ID. No record found.');
          }
        })
        .catch((error) => {
          console.error('Error fetching Event Details:', error);
          setIsIdValid(false);
          setErrorMessage('Failed to fetch Event details.');
        });
    } else {
      setIsIdValid(false);
      setErrorMessage('Invalid ID. Please try again.');
    }
  }, [id, isAuthenticated, token, logout]);




  const [head, setAccountHead] = useState("");
  const [currency, setCurrency] = useState("INR");

  const [selectedpolarity, setSelectedPolarity] = useState(null); // Initialize to null
  const optionsp = [
    { value: 1, label: 'Dr' },
    { value: 2, label: 'Cr' },
  ];
  const [nature, setNature] = useState("1");
  const optionsn = [
    { value: 1, label: 'Income' },
    { value: 2, label: 'Expenditure' },
    { value: 3, label: 'Long Term Liabilities' },
    { value: 4, label: 'Current Liabilities' },
    { value: 5, label: 'Fixed Asset' },
    { value: 6, label: 'Current Asset' },
    { value: 7, label: 'Capital' },

  ];
  const handleChange1 = (selectedOption) => {
    setNature(selectedOption); // Get selected value
    if (selectedOption && selectedOption.value) { fetchParentGroups(selectedOption.value); }

  };

  const fetchParentGroups = async (natureId) => {
    try {
      const response = await fetchData('ParentGroupApi', `/${clubId}/${branchId}/${natureId}`, token);
      if (response.responseCode === '1111') {
        const options = response.response_data.map((group) => ({
          value: group.Id,
          label: group.Head,
        }));

        //  setselectedgroup(options); // Clear previous selection (optional)
        if (options.length > 0) {
          setParent(options[0].label);
          setselectedgroup(options[0]);
        }
      } else {
        console.warn('No parent groups found for selected nature.');
        setParentGroupOptions([]);
      }
    } catch (error) {
      console.error('Error fetching parent group data:', error);
      setParentGroupOptions([]);
    }
  };



  const fetchNatureData = async () => {
    fetchData('NatureApi', `/${clubId}`, token)
      .then((response) => {
        if (response.responseCode === '1111') {

          const options = response.response_data.map(group => ({
            value: group.Id,
            label: group.Name
          }));
          setNatureOptions(options);
        }
      })
      .catch((error) => {
        console.error('Error fetching Nature Details:', error);
      });
  };
  const handleParentGroupChange = (selectedOption) => {
    setselectedgroup(selectedOption); // Store the whole object


  };
  const [opening, setOpening] = useState(0);

  const handleChange2 = (event) => {
    setSelectedPolarity(event)
  };
  const [openingdate, setOpeningDate] = useState("");



  useEffect(() => {
    fetchtableData();
    fetchNatureData();
  }, [clubId, ispayment, token]);

  const fetchtableData = async () => {
    try {
      const response = await fetchDataAccountsIncomeExpense('AccountHeadApi', `/${clubId}`, ispayment, token);
      if (response.responseCode === '1111') {
        const options = response.response_data.map(incomeexpense => ({
          value: incomeexpense.id,
          label: incomeexpense.head,
          isEvent: incomeexpense.isEvent
        }));
        if (ispayment) {
          // setExpenseOptions(options);  // Store in expense list
          const filteredOptions = options.filter(option => option.isEvent === true);
          setEventHeadExpenseOptions(filteredOptions);

        } else {

          //setIncomeOptions(options);   // Store in income list
          const filteredOptions = options.filter(option => option.isEvent === true);
          setEventHeadIncomeOptions(filteredOptions);

        }

      }
      else {
        console.warn('Unexpected response code:', response.responseCode);
        // Handle other response codes if needed
      }
    } catch (error) {
      console.error('Error fetching AccountHead Details:', error);

      // Handle unauthorized error
      if (error.response && error.response.status === 401) {
        //logout();
        history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
      } else {
        // Handle other errors, if any
        console.error('An unexpected error occurred.');
      }
    }
  };


  const fetchtableData1 = async () => {
    fetchData('PaymentAndReceiptApi', `/${clubId}`, token)
      .then((response) => {
        if (response.responseCode == '1111') {
          console.log(response);
          setData(response.response_data);

          const expenseList = response.response_data.filter(item => item.isPayment && item.eventId == id); // Filter income
          const incomeList = response.response_data.filter(item => !item.isPayment && item.eventId == id); // Filter expenses
          setIncomeSplitList(incomeList);
          setExpenseSplitList(expenseList);
        }
      })
      .catch((error) => {
        console.error('Error fetching Payment & Receipt Details:', error);
      });


  };
  //Income Edit------------------------------------------------------------------
  //------------------------------------------------------------------------------

  const [editingIndex, setEditingIndex] = useState(null);
  const [editingexpenseIndex, setExpenseEditingIndex] = useState(null);
  const [tempData, setTempData] = useState({});

  const [tempExpenseData, setTempExpenseData] = useState({});

  const handleEditClick = (index, income) => {
    setEditingIndex(index);
    setTempData({ ...income });
  };

  const handleExpenseEditClick = (index, expense) => {
    setExpenseEditingIndex(index);
    setTempExpenseData({ ...expense });
  };
  const handleInComeChange = (e) => {
    const { name, value } = e.target;
    setTempData({ ...tempData, [name]: value });
  };
  const fetchBank = async () => {
    try {
      const response = await fetchData('PersonApi', `/${clubId}`, token);

      if (response.responseCode === '1111') {
        const options = response.response_data
          .filter(party => party.isBank === true) // Filter for items where isBank is true
          .map(party => ({
            value: party.id,
            label: party.name,
          }));

        setBankOptions(options);
      }
    } catch (error) {
      console.error('Error fetching Fees:', error);
    }
  };
  const handleExpenseChange = (e) => {
    const { name, value } = e.target;
    setTempExpenseData({ ...tempExpenseData, [name]: value });
  };

  const handleIncomeSave = async () => {
    const eventincomeexpense = {
      Id: tempData.id || 0, // Default to 0 or null for new records
      Description: tempData.description,
      Amount: parseFloat(tempData.amount), // Ensure the amount is a number
      ClubId: clubId,
      EventId: id,
      ModifiedBy: userId,
      ModifiedDate: new Date(),
      CreatedBy: userId,
      CreatedDate: new Date(),
      IsIncome: true,
    };

    try {
      const response = await postDataNew('EventApi', 'AddEventIncome', eventincomeexpense, token);
      console.log('Event saved successfully:', response);
      setSuccessMessage("Event saved successfully!");
      setErrorMessage("");

      // Update the incomeexpenseList with the new or updated record
      setIncomeAndExpenseList((prevData) => {
        let updatedData;
        if (editingIndex !== null) {
          // Update existing entry
          updatedData = [...prevData];
          updatedData[editingIndex] = eventincomeexpense;
        } else {
          // Add new entry
          updatedData = [...prevData, eventincomeexpense];
        }

        // Calculate the total income and update the estimate
        const totalIncome = updatedData
          .filter(record => record.isIncome)
          .reduce((total, record) => total + record.amount, 0);
        setIncomeEstimate(totalIncome);

        const totalExpense = updatedData
          .filter(record => !record.isIncome)
          .reduce((total, record) => total + record.amount, 0);
        setExpenseEstimate(totalExpense);



        return updatedData;
      });

      clearForm();
      setEditingIndex(null); // Exit edit mode
      setTempData(null)
      setTimeout(() => {
        setSuccessMessage("");
      }, 3000);

      window.location.reload();

    } catch (error) {
      console.error('Event save error:', error);
      setErrorMessage("Failed to save event. Please try again.");
    }
  };



  const handleExpenseSave = async () => {
    try {
      const eventincomeexpense = {
        Id: tempExpenseData.id || 0, // Default to 0 or null for new records
        Description: tempExpenseData.description,
        Amount: parseFloat(tempExpenseData.amount), // Ensure the amount is a number
        ClubId: clubId,
        EventId: id,
        ModifiedBy: userId,
        ModifiedDate: new Date(),
        CreatedBy: userId,
        CreatedDate: new Date(),
        IsIncome: false,
      };

      console.log(eventincomeexpense); // Add debugging line

      const response = await postDataNew('EventApi', 'AddEventIncome', eventincomeexpense, token);
      console.log('Event saved successfully:', response);
      setSuccessMessage("Event saved successfully!");
      setErrorMessage("");

      setIncomeAndExpenseList((prevData) => {
        let updatedData;
        if (editingIndex !== null) {
          updatedData = [...prevData];
          updatedData[editingIndex] = eventincomeexpense;
        } else {
          updatedData = [...prevData, eventincomeexpense];
        }

        const totalExpense = updatedData
          .filter(record => !record.isIncome)
          .reduce((total, record) => total + record.amount, 0);
        setIncomeEstimate(totalExpense);

        return updatedData;
      });

      clearForm();
      setExpenseEditingIndex(null);
      setTempExpenseData(null);

      setTimeout(() => {
        setSuccessMessage("");
      }, 3000);

      window.location.reload();

    } catch (error) {
      console.error('Event save error:', error);
      setErrorMessage("Failed to save event. Please try again.");
    }
  };






  const handleCancel = () => {
    setEditingIndex(null); // Exit edit mode without saving
    setExpenseEditingIndex(null)

  };

  const handleDelete = async (id, index) => {
    try {
      // Check if `id` is `0`, indicating a local deletion
      if (id === 0) {
        // Remove the item from the list by index
        setIncomeAndExpenseList((prevData) => prevData.filter((_, i) => i !== index));
        console.log('Record deleted locally');
        setSuccessMessage("Record deleted successfully!");
      } else {
        // Confirm deletion if needed
        if (!window.confirm("Are you sure you want to delete this item?")) {
          return;
        }

        // Call the API to delete the data based on the `id`
        await deleteIncomeExpenseData('EventApi', 'expense', id, token);
        console.log('Record deleted successfully from the server');

        // Update the UI by removing the deleted record from the list
        setIncomeAndExpenseList((prevData) => prevData.filter(record => record.id !== id));
        setSuccessMessage("Record deleted successfully!");
      }

      setTimeout(() => {
        setSuccessMessage("");
      }, 3000);


      // Calculate the new total income after deletion
      const totalIncome = incomeexpenseList
        .filter(record => record.isIncome) // Filter income records
        .reduce((total, record) => total + (Number(record.amount) || 0), 0); // Ensure amounts are treated as numbers

      setIncomeEstimate(totalIncome); // Update income estimate

      const totalExpense = incomeexpenseList

        .filter(record => !record.isIncome)
        .reduce((total, record) => total + record.amount, 0);
      setExpenseEstimate(totalExpense);

      window.location.reload();
    } catch (error) {
      console.error('Error deleting record:', error);
      setErrorMessage("Failed to delete the record. Please try again.");
    }
  };

  //delete Participants data
  const handleDeleteParticipants = async (id, index) => {
    try {
      // Check if `id` is `0`, indicating a local deletion
      if (id === 0) {
        // Remove the item from the list by index
        setParticipantsData((prevData) => prevData.filter((_, i) => i !== index));
        console.log('Record deleted locally');
        setSuccessMessage("Record deleted successfully!");
      } else {
        // Confirm deletion if needed
        if (!window.confirm("Are you sure you want to delete this item?")) {
          return;
        }

        // Call the API to delete the data based on the `id`
        await deleteIncomeExpenseData('EventApi', 'participants', id, token);
        console.log('Record deleted successfully from the server');

        // Update the UI by removing the deleted record from the list
        setParticipantsData((prevData) => prevData.filter(record => record.id !== id));
        setSuccessMessage("Record deleted successfully!");
      }

      setTimeout(() => {
        setSuccessMessage("");
      }, 3000);

      window.location.reload();
    } catch (error) {
      console.error('Error deleting record:', error);
      setErrorMessage("Failed to delete the record. Please try again.");
    }
  };


  //--------------------------------------------------------------------------------------

  //--------------------------------------------------------------------------------------
  //-------------------Participants Edit-----------------------------

  const [participantId, setParticipantId] = useState(null); // Store the ID of the participant being edited

  const handleParticipantsEditClick = (id, phoneNumber) => {
    setParticipantId(id);  // Store the ID of the participant being edited
    setEditMode(id);  // Enable edit mode for the selected row
    setEditedPhone(phoneNumber);  // Pre-fill the input field with the current phone number
  };







  const handleParticipantsSave = async () => {
    const participants = {
      Id: participantId, // Default to 0 or null for new records
      PhoneNumber: editedPhone,
      ModifiedBy: userId,
      ModifiedDate: new Date(),
    };
    try {
      const response = await updateDataNew('EventApi', 'UpdateParticipants', participantId, 'someTmpType', participants, token);
      console.log('Event saved successfully:', response);
      setSuccessMessage("Event saved successfully!");
      setErrorMessage("");
      // Update the incomeexpenseList with the new or updated record
      setIncomeAndExpenseList((prevData) => {
        let updatedData;
        if (editingIndex !== null) {
          // Update existing entry
          updatedData = [...prevData];
          updatedData[editingIndex] = participants;
        } else {
          // Add new entry
          updatedData = [...prevData, participants];
        }

        // Calculate the total income and update the estimate
        setEditMode(null);

        return updatedData;
      });

      clearForm();
      setEditingIndex(null); // Exit edit mode
      setTempData(null)
      setTimeout(() => {
        setSuccessMessage("");
      }, 3000);

      window.location.reload();

    } catch (error) {
      console.error('Event save error:', error);
      setErrorMessage("Failed to save event. Please try again.");
    }
  };









  // Handle cancel button click
  const handleParticipantsCancel = () => {
    setEditMode(null); // Exit edit mode without saving changes
  };

  //-------------------------------------------------------------



  const formatDateForInput = (dateString) => {
    if (!dateString) return ''; // Handle cases where dateString is undefined or null
    const currentDate = new Date(dateString);
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`; // Format as YYYY-MM-DD for input[type="date"]
  };

  const clearForm = () => {
    setEventName(""); setFromDate("");
    setToDate(""); setDescription("");
    setVenue(""); setIncomeEstimate("");
    setExpenseEstimate(""); setIncomeActual("");
    setExpenseActual("");

  };
  const [formData, setFormData] = useState({
    event: '',
    description: '',
    venue: '',
    fromDate: '',
    toDate: '',
    incomeestimate: '',
    expenseestimate: '',
    incomeActual: '',
    expenseActual: '',
    createdBy: '',
    createdDate: '',
    clubId: '',
    eventId: '',
    id: '',
  });

  const handleFormSubmit = (e) => {
    e.preventDefault();
    setIsSubmit(true);
    handleSubmit(e);

  }
  const handlePrChange = (e) => {
    e.preventDefault();
    setIsPaymentandReceipt(true);
    fetchBillno();
  }
  const handleBankChange = (dropdownOption) => {
    setSelectedBank(dropdownOption);
    fetchBank();
  };
  const handleSubmit
    = async (e) => {
      e.preventDefault();

      if (!formData.event || !formData.venue || !formData.fromDate || !formData.toDate) {
        setErrorMessage("Event name, venue, from date, and to date are mandatory.");
        return;
      }

      const EventMasterDatas = {
        Id: formData.id,
        Event: formData.event,
        Description: formData.description,
        Venue: formData.venue,
        FromDate: formData.fromDate,
        ToDate: formData.toDate,
        IncomeEstimate: incomeestimate,
        ExpenseEstimate: expenseestimate,
        IncomeActual: formData.incomeActual,
        ExpenseActual: formData.expenseActual,
        CreatedBy: formData.createdBy,
        CreatedDate: formData.createdDate,
        ModifiedBy: userId,
        ModifiedDate: new Date(),
        ClubId: clubId || "",

      };




      const Participants =
        participantsData.map(party => ({
          Id: party.id,
          MemberName: party.memberName,
          PhoneNumber: party.phoneNumber,
          Remarks: party.remarks,
          MemberId: party.memberId,
          FamilyMemberId: party.familyMemberId,
          MemberType: party.memberType,
          CreatedBy: party.id === 0 ? userId : party.createdBy,  // Conditionally set CreatedBy
          CreatedDate: party.id === 0 ? new Date() : party.createdDate,  // Conditionally set CreatedDate
          ModifiedBy: party.id === 0 ? userId : party.modifiedBy,
          ModifiedDate: party.id === 0 ? new Date() : party.modifiedDate,
          EventId: party.eventId,

        }));


      const IncomeAndExpense = incomeexpenseList.map(incomedata => ({
        Id: incomedata.id,
        EventId: incomedata.eventId,
        Description: incomedata.description,
        Amount: incomedata.amount,
        IsIncome: incomedata.isIncome,
        CreatedBy: userId || null,
        HeadId: incomedata.headId || null,
        CreatedDate: new Date(),
      }));

      const EventAndChild = {
        EventMasterData: EventMasterDatas,
        EventParticipantsData: Participants,
        EventIncomeAndExpenseData: IncomeAndExpense
      };


      try {
        const response = await updateData('EventApi', id, EventAndChild, token);
        console.log('Record updated successfully:', response);

        setTimeout(() => {
          setSuccessMessage("");
        }, 3000);

        history.push('/EventIndex');

      } catch (error) {
        console.error('Error updating record:', error);
      }
    };

  const fetchMember = async () => {
    try {
      // Construct params1 and params2
      const params1 = `/${clubId}`;
      const params2 = `?branchId=${branchId}`;

      //const response = await fetchData1('MemberApi', params1, params2, token);
      const response = await fetchData1('MemberApi', `/${clubId}/${branchId}`, token);
      if (response.responseCode === '1111') {
        const options = response.response_data.map(member => ({
          value: member.id,
          //label: member.firstName,
          label: `${member.firstName} ${member.lastName}`,  // Only format for the select dropdown
          firstName: member.firstName,
          lastname: member.lastName,
          phoneNumber: member.phoneNumber,
          email: member.email,
        }));
        setMemberOptions(options);
      }
    } catch (error) {
      console.error('Error fetching table data:', error);
    }
  };

  const fetchFamilyMembers = async (memberId) => {
    try {
      const response = await fetchData('MemberApi', `/GetMemberDetails/${memberId}`, token); // Use your API endpoint
      if (response.responseCode === '1111') {
        setFamilyMembers(response.response_data.familydata || []); // Update the family members state
      }
    } catch (error) {
      console.error('Error fetching family members:', error);
    }
  };
  const handleMemberSelectChange = (selectedOption) => {
    setSelectedMember(selectedOption.value);
    setPersonModalOpen(true);
  };

  const [isModalOpenNonMember, setIsModalOpenNonMember] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFamilyMemberModalOpen, setIsFamilyMemberModalOpen] = useState(false);
  const [isModalOpenIncome, setIsModalOpenIncome] = useState(false);
  const [isModalOpenExpense, setIsModalOpenExpense] = useState(false);
  const [newRecordData, setNewRecordData] = useState({
    memberName: '',
    remarks: '',
    phoneNumber: '',
    memberId: [],
    familyMemberId: '',
    memberType: '',
  });
  const [incomeData, setIncomeData] = useState({
    Description: '',
    Amount: '',
    IsIncome: true,
    HeadId: ''
  });

  const [expenseData, setExpenseData] = useState({
    Description: '',
    Amount: '',
    IsIncome: false,
    HeadId: ''
  });


  const toggleModalNonMember = () => {
    setIsModalOpenNonMember(prev => !prev);
    //setMemberType("");
  };

  const toggleModal = () => {
    setIsModalOpen(prev => !prev);
    //setMemberType("");
  };

  const toggleFamilyModal = () => {
    setIsFamilyMemberModalOpen(prev => !prev);
    //inputRef.current.focus();
    //setMemberType("");
  };
  const toggleModalIncome = () => {
    setIsModalOpenIncome(prev => !prev);

  };
  const toggleModalNewHead = () => {
    setIsModalOpenCreateHead(prev => !prev);


  };
  const toggleModalCloseHead = () => {
    setIsModalOpenCreateHead(prev => !prev);

  };


  const toggleModalExpense = () => {
    setIsModalOpenExpense(prev => !prev);
  };

  const toggleModalClose = () => {
    setIsModalOpen(prev => !prev);
    setMemberType("");
  };

  const toggleIncomeModalClose = () => {
    setincomeActualSplit(prev => !prev);
  };
  const toggleExpenseModalClose = () => {
    setexpenseActualSplit(prev => !prev);
  };

  const toggleFamilyModalClose = () => {
    setIsFamilyMemberModalOpen(prev => !prev);
    setMemberType("");



  };

  const fetchtableData2 = async () => {
    try {
      const response = await fetchDataAccountsIncomeExpense('AccountHeadApi', `/${clubId}`, true, token);
      if (response.responseCode === '1111') {
        const options = response.response_data.map(incomeexpense => ({
          value: incomeexpense.id,
          label: incomeexpense.head,
          isEvent: incomeexpense.isEvent
        }));
        const filteredOptions = options.filter(option => option.isEvent === true);
        setEventIncomeExpenseOption1(filteredOptions);
      }
      else {
        console.warn('Unexpected response code:', response.responseCode);
        // Handle other response codes if needed
      }
    } catch (error) {
      console.error('Error fetching AccountHead Details:', error);

      // Handle unauthorized error
      if (error.response && error.response.status === 401) {
        //logout();
        history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
      } else {
        // Handle other errors, if any
        console.error('An unexpected error occurred.');
      }
    }
  };

  const togglePrClose = () => {

    setIsPaymentandReceipt(prev => !prev);
    setPaymentType('0');
    setEventIncomeExpenseOption("");

  };
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setNewRecordData((prevData) => ({
      ...prevData,
      [name]: value
    }));
    setMemberType(value);

    // Open modals based on selection
    if (value === "1") {
      toggleModalNonMember();
    }
    else if (value === "2") {
      toggleModal(); // Open modal if Member is selected
    } else if (value === "3") {
      toggleFamilyModal(isFamilyMemberModalOpen); // Open family member modal
    } else {
      // Close both modals if Non-Member is selected
      setIsModalOpen(false);
      setIsFamilyMemberModalOpen(false);
    }
  };

  const handleIncomeInputChange = (event) => {
    const { name, value } = event.target;
    setIncomeData((prevData) => ({
      ...prevData,
      [name]: value, // Update the corresponding field in income data
    }));
  };


  const addRecord = () => {
    // Add the selected members to participants data
    const newParticipants = selectedMemberlist.map((memberId) => {
      const selectedMember = memberlist.find((member) => member.value === memberId);
      return {
        memberName: selectedMember.label,
        phoneNumber: selectedMember.phoneNumber || '1234567890', // Fetch the actual phone number if available
        remarks: memberId !== 0 ? 'C-M' : 'N-M',
        memberId: selectedMember.value,
        familyMemberId: 0,
        memberType: 2
      };
    });

    // Update participantsData with the new records
    const existingData = new Set(participantsData.map(p => p.memberId));
    const uniqueParticipants = newParticipants.filter(newParticipant =>
      !existingData.has(newParticipant.memberId) && newParticipant.memberType === 2
    );

    //const uniqueParticipants = newParticipants.filter(newParticipant => !existingData.has(newParticipant.memberId));
    setParticipantsData((prevData) => [...prevData, ...uniqueParticipants]);
    // setParticipantsData((prevData) => [...prevData, ...uniqueParticipants]);

    setFilterParticipantsData((prevData) => [...prevData, ...uniqueParticipants]);
    // Reset the selection
    setSelectedMemberList([]);
    setSelectedMembers({});
    setMemberType("");

    // Close modal
    setIsModalOpen(false);
  };
  const addNonMemberRecord = () => {
    // Create a new participant object from the form input data
    const newParticipant = {
      memberName: newRecordData.MemberName, // Name entered by user
      phoneNumber: newRecordData.phoneNumber || '1234567890', // Fallback if phone number is not provided
      remarks: 'Non-Member', // Non-Member since this is a non-member entry
      memberId: 0, // Assuming 0 represents non-members
      familyMemberId: 0, // Not a family member in this case
      memberType: 1 // Non-member type
    };

    // Update participantsData with the new non-member record
    setParticipantsData((prevData) => [...prevData, newParticipant]);
    setFilterParticipantsData((prevData) => [...prevData, newParticipant]);
    // Reset the form input fields
    setNewRecordData({ MemberName: '', phoneNumber: '' });

    // Close the modal
    toggleModalNonMember();
  };




  const addIncomeRecord = () => {
    const newIncome = {
      isIncome: isincome,
      //description: isincome ? `${incomeData.Description} (Income)` : `${incomeData.Description} (Expense)`,
      description: eventIncomeExpenseselectedOption1?.label || incomeData.Description,
      amount: parseFloat(incomeData.Amount), // Ensure the amount is a number
      headId: eventIncomeExpenseselectedOption1?.value || 0,
    };

    // Update the income data list with the new record
    setIncomeAndExpenseList((prevData) => {
      const updatedData = [...prevData, newIncome];
      // Calculate the total income after adding the new record
      const totalIncome = updatedData
        .filter(record => record.isIncome) // Only include income records
        .reduce((total, record) => total + record.amount, 0);

      const totalExpense = updatedData
        .filter(record => !record.isIncome) // Only include income records
        .reduce((total, record) => total + record.amount, 0);

      // Update the Income Estimate field
      setIncomeEstimate(totalIncome);
      setExpenseEstimate(totalExpense);
      return updatedData;
    });

    toggleModalIncome();
  };




  const addExpenseRecord = () => {
    const newExpense = {
      isIncome: false,
      description: expenseData.IsIncome
        ? `${expenseData.Description} (Income)`
        : `${expenseData.Description} (Expense)`, // Conditionally add (Income) or (Expense) based on isIncome
      //description: expenseData.Description,
      amount: parseFloat(expenseData.Amount), // Ensure the amount is a number
    };

    // Update the expense data list with the new record
    setIncomeAndExpenseList((prevData) => {
      const updatedData = [...prevData, newExpense];

      // Calculate the total expense after adding the new record
      const totalExpense = updatedData
        .filter(record => !record.isIncome) // Only include income records
        .reduce((total, record) => total + record.amount, 0);

      // Update the Expense Estimate field
      setExpenseEstimate(totalExpense);

      return updatedData;
    });
    toggleModalExpense();
  };

  // Handle checkbox state change
  const handleCheckboxChange = (event, memberId) => {
    if (event.target.checked) {
      // Add member to selected list
      setSelectedMemberList(prevState => [...prevState, memberId]);
      setSelectedMembers(prevState => ({
        ...prevState,
        [memberId]: 0 // Set default quantity (if needed)
      }));
    } else {
      // Remove member from selected list
      setSelectedMemberList(prevState => prevState.filter(id => id !== memberId));
      setSelectedMembers(prevState => {
        const newState = { ...prevState };
        delete newState[memberId]; // Remove quantity for deselected item
        return newState;
      });
    }
  };

  const handleCheckboxChangeFamily = (event, familymemeberId) => {
    if (event.target.checked) {
      // Add member to selected list
      setSelectedMemberList(prevState => [...prevState, familymemeberId]);
      setSelectedMembers(prevState => ({
        ...prevState,
        [familymemeberId]: 0 // Set default quantity (if needed)
      }));
    } else {
      // Remove member from selected list
      setSelectedMemberList(prevState => prevState.filter(id => id !== familymemeberId));
      setSelectedMembers(prevState => {
        const newState = { ...prevState };
        delete newState[familymemeberId]; // Remove quantity for deselected item
        return newState;
      });
    }
  };
  const handleSearchChange = (e) => {
    const searchValue = e.target.value;
    setSearchText(searchValue);

    // Filtering based on the current input value (not the stale state value)
    let filteredParticipants = "";

    if (searchValue === "") {
      filteredParticipants = participantsData;  // No filter, use original data when search is empty
    } else {
      filteredParticipants = participantsData.filter(participant =>
        participant.memberName.toLowerCase().includes(searchValue.toLowerCase())
      );
    }
    setFilterParticipantsData(filteredParticipants);
  };



  // Handle select/deselect all
  const handleSelectAllChange = (event) => {
    const isChecked = event.target.checked;
    setSelectAllChecked(isChecked);

    if (isChecked) {
      // Select all members
      const allMemberIds = memberlist.map((member) => member.value);
      setSelectedMemberList(allMemberIds);
      const allSelectedMembers = {};
      memberlist.forEach((member) => {
        allSelectedMembers[member.value] = 0; // Add default value or required state
      });
      setSelectedMembers(allSelectedMembers);
    } else {
      // Deselect all members
      setSelectedMemberList([]);
      setSelectedMembers({});
    }
  };

  // Handle select/deselect all
  const handleSelectAllChangeFamily = (event) => {
    const isChecked = event.target.checked;
    setSelectAllChecked(isChecked);

    if (isChecked) {
      // Select all members
      const allMemberIds = familyMembers.map((member) => member.id);
      setSelectedMemberList(allMemberIds);
      const allSelectedMembers = {};
      familyMembers.forEach((member) => {
        allSelectedMembers[member.id] = 0; // Add default value or required state
      });
      setSelectedMembers(allSelectedMembers);
    } else {
      // Deselect all members
      setSelectedMemberList([]);
      setSelectedMembers({});
    }
  };


  useEffect(() => {
    fetchMember();
    fetchtableData2();
    fetchParentData();
  }, []);


  const fetchParentData = async () => {
    fetchData('ParentGroupApi', `/${clubId}`, token)
      .then((response) => {

        if (response.responseCode === '1111') {

          const options = response.response_data.map(group => ({
            value: group.Id,
            label: group.Name
          }));
          setParentGroupOptions(options);
        }
      })
      .catch((error) => {
        console.error('Error fetching Parent Group Details:', error);
      });
  };
  const handleChange = (event) => {
    const { name, value, type } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'checkbox' ? !prevData[name] : value,
    }));
  };
  const handleDoubleClick = (e) => {
    setincomeActualSplit(true);
  };
  const handleDoubleClick1 = (e) => {
    setexpenseActualSplit(true);
  };

  const handlePaymentTypeChange = (e) => {
    setPaymentType(e.target.value);
  };

  const handleSearchmemberChange = (e) => {
    setSearchMember(e.target.value);
  };
  const filteredmembers = memberlist.filter(participant =>
    participant.label.toLowerCase().includes(searchMember.toLowerCase())
  );
  const addSelectedFamilyMembers = () => {
    // Check if any family members are selected
    if (selectedMemberlist.length === 0) {
      alert("Please select at least one family member."); // Provide feedback if no members are selected
      return;
    }

    const newParticipants = selectedMemberlist.map(memberId => {
      const familyMember = familyMembers.find(member => member.id === memberId);

      if (!familyMember) {
        console.error(`Family member with id ${memberId} not found.`);
        return null; // Return null for non-existent members
      }

      return {
        memberName: familyMember.name,
        phoneNumber: familyMember.phoneNumber || 'N/A',
        remarks: 'Family Member',
        memberId: familyMember.memberId,
        familyMemberId: familyMember.id,
        memberType: 3

      };
    }).filter(participant => participant !== null); // Filter out any null entries

    // Avoid adding duplicates
    const existingNames = new Set(participantsData.map(p => p.familyMemberId));
    const uniqueParticipants = newParticipants.filter(newParticipant => !existingNames.has(newParticipant.familyMemberId));

    // Update participants data
    setParticipantsData(prevData => [...prevData, ...uniqueParticipants]);
    setFilterParticipantsData(prevData => [...prevData, ...uniqueParticipants]);
    // Close the modal
    setIsFamilyMemberModalOpen(false);
    setMemberType("");
    setSelectedMemberList([]); // Clear selected members
    setSelectAllChecked(false); // Clear the "select all" checkbox if used
    // // Provide success feedback (optional)
    // if (uniqueParticipants.length > 0) {
    //   alert(`${uniqueParticipants.length} family member(s) added successfully.`);
    // }
  };
  const handleIncomeExpenseChange = (dropdownOption) => {
    setEventIncomeExpenseOption(dropdownOption); // Event Income/Expense
  };



  const SavePr = async (e) => {
    e.preventDefault();




    if (!billNo) {
      setErrorMessage("All fields are required!");
      setIsSubmit(false);
      return;
    }

    let childData = []; // Initialize an empty array for child data

    // Check if dues list has values and paymentType is Monthly





    // Master data object to send
    const masterdata = {
      BillNo: billNo,
      BillDate: billDate || "",
      Amount: parseFloat(amount),
      IsPayment: ispayment,
      Type: 2,
      IncomeOrExpenseId: eventIncomeExpenseOption.value || null,
      EventId: formData.id,
      MemberId: 0,
      Dues: 0 || null,
      FeesDescriptionId: 0 || null,
      PartyId: 0,
      Description: description1 || "",
      ChequeNo: chequeNo || "",
      IsActive: true,
      ChequeDate: chequeDate || null,
      BankId: selectedbank?.value || null,
      CreatedBy: userId || "",
      CreatedDate: new Date(),
      ClubId: clubId || null,
      Bank: '',
      Event: '',
      Member: '',
      Party: '',
      clubIncomeExpense: '',
      eventIncomeExpense: '',
      Fees: '',
      FinancialYear: '',
      PaymentType: paymentType.value,
    };

    // Prepare the object to send to the API (master data + child data)
    const PRAndChild = {
      PRMasterData: masterdata,
      PRChildData: childData, // Send empty array even if no child data
    };

    try {
      // Post data to the API
      const response = await postData('PaymentAndReceiptApi', PRAndChild, token);
      console.log('Payment & Receipt Created success:', response);
      setSuccessMessage("Payment & Receipt Created successfully!");
      setErrorMessage("");
      clearForm();

      setTimeout(() => {
        setSuccessMessage("");
      }, 3000);
      window.location.reload();
    } catch (error) {
      console.error('Payment & Receipt Create error:', error);
      setErrorMessage("An error occurred while saving the data.");
    }
  };

  useEffect(() => {
    fetchBillno();
  }, [ispayment, clubId, branchId, token]);

  const fetchBillno = async () => {
    try {
      const response = await fetchData('PaymentAndReceiptApi', `/GetBillNo/${clubId}/${branchId}/${ispayment}`, token);  // Capture the result of fetchData
      if (response.responseCode === '1111') {
        setBillNo(response.response_data.billno);
      }
    } catch (error) {
      console.error('Error fetching Fees:', error);
    }
  };
  const [page, setPage] = useState(0); // Current page
  const [rowsPerPage, setRowsPerPage] = useState(5); // Rows per page
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const paginatedData = incomeexpenseList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  const paginatedData1 = filterparticipantsData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to the first page when changing rows per page
  };



  //-----------------------------Family details---------------

  //------------------Account Head datas----------------------
  const handleFormSubmit1 = (e) => {
    e.preventDefault();
    setIsSubmit1(true);
    submitData1(e);

  }


  const submitData1 = async (e) => {
    e.preventDefault();


    // Validation
    if (head === "" || opening === undefined || opening === null) {
      setErrorMessage("All fields are required!");
      setIsSubmit1(false);
      return;
    }
    const accountheads = {
      Head: head,
      Currency: currency,
      NatureId: nature.value,
      ParentGroupId: selectedgroup.value,
      ParentGroup: selectedgroup.label,
      Nature: nature.label,
      OpeningBalancePolarity: selectedpolarity.label,
      OpeningBalancePolarityId: selectedpolarity.value,
      OpeningBalanceDate: openingdate,
      OpeningBalanceAmt: opening,
      IsExpense: isExpense, // Set FromDate to null if One Time
      IsMeetingExpense: false,     // Set ToDate to null if One Time
      CreatedBy: userId || "",
      CreatedDate: new Date(),
      ClubId: clubId || "",
      BranchId: branchId || "",
      IsEvent: true,
      FeesId: 0,
      IsFees: false,

    };

    try {
      const response = await postData('AccountHeadApi', accountheads, token);
      console.log('Account Head Created successfully:', response);
      setSuccessMessage("Account Head Created successfully!");
      setErrorMessage("");

      // resetForm(); // Ensure this function resets all relevant state variables
      setTimeout(() => {
        setSuccessMessage("");
      }, 3000);
      // window.location.reload();
    } catch (error) {
      console.error('Account Head Create error:', error);
      setErrorMessage("Error creating Account Head. Please try again.");
    }
    toggleModalCloseHead();

  };
  const closeModal = () => {
    setPersonModalOpen(false);
  }

  const handleSearchChange1 = (e) => {
    setSearchTerm(e.target.value);
    setPersonModalOpen(true); // Open modal when typing in the search box
  };


  const handleRowClick = (member) => {
    const selectedOption = { value: member.value, label: member.label }
    //setSelectedMember(selectedOption);
    setSelectedMember(selectedOption.value);
    setSearchTerm(selectedOption.label); // Display the selected name in the search box
    setPersonModalOpen(false); // Close modal after selecting a member
    setMemberId(selectedOption.value);
    fetchFamilyMembers(selectedOption.value);

  };



  return (
    <Fragment>
      <div className="w-full max-w-sm container mt-2 mx-auto" style={{ maxWidth: '95%' }}>

        <div className="w-full flex justify-between items-center flex-wrap">
          {/* Heading on the left */}
          <h6 className='productHead linkcolor'

            style={{ color: '#14528B', padding: '7px', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', marginLeft: '-2%' }}>
            EVENT EDIT
          </h6>

          {/* Buttons on the right */}
          <div className="flex mt-2">
            <Tooltip title="Entry Payment & Receipt">
              <Button style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#5DB996', marginLeft: '5px', height: '25px' }}
                component="a"
                href={`/PRCreateFromEvent/${id}`}
                target="_blank"
                rel="noopener noreferrer">
                Payment & Receipt
              </Button>
            </Tooltip>
            <Tooltip title="Update Event">
              <Button onClick={handleFormSubmit} style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#347928', height: '25px', marginLeft: '5px' }}>
                UPDATE
              </Button>
            </Tooltip>
            <Tooltip title="Cancel">
              <Button style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#C62300', marginLeft: '5px', height: '25px' }}>
                <Link to="/EventIndex" className="linkcolor" style={{ textDecoration: 'none', color: 'inherit' }}>
                  CANCEL
                </Link>
              </Button>
            </Tooltip>


          </div>
        </div>

        {errorMessage && <p className="text-red-500">{errorMessage}</p>}
        {successMessage && <p className="text-green-500">{successMessage}</p>}

        <div className="w-full flex flex-wrap" style={{ marginLeft: '-1%' }}>
          {/* <div className="w-full sm:w-3/5"> */}
          <div className="w-full mb-2 flex" style={{ marginLeft: '-1%' }}>
            <div className="w-1/4 mr-2">
              <label htmlFor="eventname">Event Name
                <span className="text-red-500 ml-1">*</span>
              </label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                name="event"
                value={formData.event}
                onChange={handleChange}
                type="text"
                placeholder="Enter Event Name"
              />
            </div>
            <div className="w-1/10 mr-2">
              <label htmlFor="fromdate">From
                <span className="text-red-500 ml-1">*</span>
              </label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                name="fromDate"
                value={formatDateForInput(formData.fromDate)}
                onChange={handleChange}
                type="date"
                placeholder="Select From Date"
              />
            </div>
            <div className="w-1/10 mr-2">
              <label htmlFor="todate">To
                <span className="text-red-500 ml-1">*</span>
              </label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                name="toDate"
                value={formatDateForInput(formData.toDate)}
                onChange={handleChange}
                type="date"
                placeholder="Select To Date"
              />
            </div>
            <div className="w-1/2 mr-2">
              <label htmlFor="description">Description</label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                name="description"
                value={formData.description}
                onChange={handleChange}
                type="text"
                placeholder="Select description"
              />
            </div>

          </div>
          <div className="w-full sm:w-3/5 pl-2" style={{ marginLeft: '-1%' }}>
            <div className="w-full mb-2 flex" style={{ marginLeft: '-1%' }}>
              <div className="w-full mr-2">
                <label htmlFor="venue">Venue
                  <span className="text-red-500 ml-1">*</span>
                </label>
                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                  name="venue"
                  value={formData.venue}
                  onChange={handleChange}
                  type="text"
                  placeholder="Enter Venue"
                />
              </div>
              <div className="w-full mr-2">
                <label htmlFor="incomeestimate">Income EST</label>
                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                  name="incomeestimate"

                  value={Number(incomeestimate).toFixed(2)}


                  onChange={(e) => setIncomeEstimate(e.target.value)}
                  type="text"
                  placeholder="Income Estimate"
                />
              </div>
              <div className="w-full mr-2">
                <label htmlFor="expenseestimate">Expense EST</label>
                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                  name="expenseestimate"
                  value={Number(expenseestimate).toFixed(2)}
                  onChange={(e) => setExpenseEstimate(e.target.value)}
                  type="text"
                  placeholder="Expense Estimate"
                />
              </div>
              <div className="w-full mr-2">
                <label htmlFor="incomeactual">Income Actual</label>
                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                  name="incomeActual"
                  value={Number(formData.incomeActual).toFixed(2)}
                  onChange={handleChange}
                  onDoubleClick={handleDoubleClick}
                  type="text"
                  placeholder="Income Actual"
                />
              </div>

              <div className="w-full mr-2">
                <label htmlFor="expenceactual">Expense Actual</label>
                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                  name="expenseActual"

                  value={Number(formData.expenseActual).toFixed(2)}
                  onDoubleClick={handleDoubleClick1}
                  onChange={handleChange}
                  type="text"
                  placeholder="Expense Actual"
                />
              </div>



            </div>

          </div>


          <div className="w-full flex flex-wrap">
            {/* Income Details Table */}
            <div className="w-full sm:w-2/5 pl-2">
              <div className='w-full mb-5 flex' style={{ maxHeight: '400px', overflowY: 'auto' }}>

                <TableContainer component={Paper} style={{ width: '120%' }}>
                  <Table>
                    <TableHead sx={{ backgroundColor: '#f3f3f3' }}>
                      <TableRow>

                        <TableCell onClick={toggleModalIncome} colSpan={4} sx={{ borderBottom: '1px solid #ddd', textAlign: 'center', padding: '2px', fontSize: '14px', fontWeight: 'bold' }}><span style={{ color: 'green' }}>  Income Details</span> <span style={{ marginLeft: '2.5px' }}></span>/<span style={{ color: 'brown', marginLeft: '2.5px' }}>Expense</span> Details
                          {/* <IconButton onClick={toggleModalIncome} aria-label="add"> */}
                          <AddIcon style={{ marginLeft: '5px', fontSize: '15px' }} />
                          {/* </IconButton> */}
                        </TableCell>


                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '5px' }}>Description</TableCell>
                        <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '5px' }}>Amount</TableCell>
                        <TableCell sx={{ borderBottom: '1px solid #ddd', textAlign: 'center', padding: '5px' }}>

                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {Array.isArray(paginatedData) && paginatedData.map((income, index) => (
                        <TableRow key={index}>
                          {editingIndex === index ? (
                            <>
                              <TableCell style={{ width: '17%', padding: '2px' }}>
                                <input
                                  name="description"
                                  value={tempData.description || ''}
                                  onChange={handleInComeChange}
                                />
                              </TableCell>
                              <TableCell style={{ width: '10%', padding: '2px' }}>
                                <input
                                  name="amount"
                                  value={tempData.amount || ''}
                                  onChange={handleInComeChange}
                                />
                              </TableCell>
                              <TableCell style={{ width: '10%', padding: '2px' }}>
                                <IconButton onClick={handleIncomeSave} aria-label="save">
                                  <SaveIcon style={{ color: 'blue', fontSize: '20px', fontWeight: 'bold' }} />
                                </IconButton>
                                <IconButton onClick={handleCancel} aria-label="cancel">
                                  <CancelIcon style={{ color: 'red', fontSize: '20px', fontWeight: 'bold' }} />
                                </IconButton>
                              </TableCell>
                            </>
                          ) : (
                            <>
                              {/* Check the isIncome flag to determine whether to append (Income) or (Expense) */}
                              <TableCell style={{ width: '40%', padding: '2px' }}>
                                {`${index + 1}) ${income.description ? `${income.description} (${income.isIncome ? 'Income' : 'Expense'})` : ''}`}

                              </TableCell>
                              <TableCell style={{ width: '10%', padding: '2px' }}>
                                {income.amount}
                              </TableCell>
                              <TableCell style={{ width: '10%', padding: '2px' }}>
                                <Box display="flex" alignItems="center" justifyContent="space-between">
                                  <Tooltip title="Edit">
                                    <IconButton onClick={() => handleEditClick(index, income)} aria-label="edit" size="small">
                                      <EditIcon style={{ color: 'teal', fontSize: '20px', fontWeight: 'bold' }} />
                                    </IconButton>
                                  </Tooltip>
                                  <Tooltip title="Delete">
                                    <IconButton onClick={() => handleDelete(income.id || 0, index)} aria-label="delete" size="small">
                                      <DeleteIcon style={{ color: 'red', fontSize: '20px', fontWeight: 'bold', marginLeft: '-2%' }} />
                                    </IconButton>
                                  </Tooltip>
                                </Box>
                              </TableCell>
                            </>
                          )}
                        </TableRow>
                      ))}
                    </TableBody>


                  </Table>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 15]}
                    component="div"
                    count={incomeexpenseList.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    sx={{
                      '& .MuiTablePagination-toolbar': {
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexWrap: 'nowrap', // Ensures everything stays in one line
                        minHeight: '40px', // Keeps a proper height
                      },
                      '& .MuiTablePagination-selectLabel': {
                        marginBottom: 0, // Fixes label misalignment
                      },
                      '& .MuiTablePagination-displayedRows': {
                        marginBottom: 0, // Fixes row count misalignment
                      },
                    }}
                  />

                </TableContainer>




              </div>
            </div>


            {/* Event Participants Table */}
            <div className="w-full sm:w-3/5 pl-2">
              <div className="w-full mb-4 flex" style={{ maxHeight: '400px', overflowY: 'auto' }}>



                <TableContainer component={Paper}>

                  <Table>
                    <TableHead sx={{ backgroundColor: '#f3f3f3' }}>
                      <TableRow>
                        <TableCell colSpan={6} sx={{ borderBottom: '1px solid #ddd', textAlign: 'center', padding: '7px', fontSize: '14px', fontWeight: 'bold' }}>


                          <input
                            className="shadow text-gray-700 leading-tight"
                            type="text"
                            placeholder="Search..."
                            value={searchText}
                            onChange={handleSearchChange}
                            onFocus={() => setIsFocused(true)}
                            onBlur={() => setIsFocused(false)}
                            style={{
                              width: isFocused ? '200px' : '170px',
                              height: '30px',
                              border: '1px solid #ccc',
                              borderRadius: '15px',
                              padding: '0 20px',
                              transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                              outline: 'none',
                              borderColor: isFocused ? 'darkcyan' : '#ccc',
                              boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                            }}
                          />

                          <span style={{ marginLeft: '5px' }}> Event Participants </span> <span style={{ color: 'brown' }}>Select Member :</span>


                          <select
                            name="membertype"
                            value={membertype}
                            onChange={handleInputChange}
                            className="ml-2 p-2 border rounded"
                          >
                            <option value="">Select an option</option>
                            <option value="1">Non-Member</option>
                            <option value="2">Member</option>
                            <option value="3">Family-Member</option>
                          </select>
                          {/* </label> */}
                          {/* </div> */}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '5px', width: '30%' }}>Name</TableCell>
                        <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '5px', width: '20%' }}>Phone No</TableCell>
                        <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '5px', width: '20%' }}>Remarks</TableCell>

                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {paginatedData1.map((childdata, index) => (
                        <TableRow key={index}>
                          <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '2px', width: '20%' }}>
                            {`${index + 1}) ${childdata.memberName || ''}`}

                          </TableCell>
                          <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '2px' }}>
                            {editMode === childdata.id ? (
                              <TextField
                                value={editedPhone}
                                onChange={(e) => setEditedPhone(e.target.value)}
                                size="small"
                                variant="outlined"
                                fullWidth
                                style={{ width: '60%' }}
                              />
                            ) : (
                              childdata.phoneNumber !== '0' ? childdata.phoneNumber : 'N/A'
                            )}
                            {editMode === childdata.id ? (
                              <>
                                <IconButton onClick={() => handleParticipantsSave(childdata.id)} aria-label="save" size="small">
                                  <SaveIcon style={{ color: 'blue', fontSize: '20px', fontWeight: 'bold' }} />
                                </IconButton>
                                <IconButton onClick={handleParticipantsCancel} aria-label="cancel" size="small">
                                  <CancelIcon style={{ color: 'red', fontSize: '20px', fontWeight: 'bold' }} />
                                </IconButton>
                              </>
                            ) : (
                              <IconButton onClick={() => handleParticipantsEditClick(childdata.id, childdata.phoneNumber)} aria-label="edit" size="small">
                                {/* <EditIcon style={{ color: 'teal', fontSize: '20px', fontWeight: 'bold' }} /> */}
                              </IconButton>
                            )}
                          </TableCell>
                          <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '2px' }}>{childdata.remarks}
                            <IconButton onClick={() => handleParticipantsEditClick(childdata.id, childdata.phoneNumber)} aria-label="edit" size="small">
                              <EditIcon style={{ color: 'teal', fontSize: '20px', fontWeight: 'bold' }} />
                            </IconButton>
                            <IconButton onClick={() => handleDeleteParticipants(childdata.id || 0, index)} aria-label="delete" size="small">
                              <DeleteIcon style={{ color: 'red', fontSize: '20px', fontWeight: 'bold' }} />
                            </IconButton>


                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>

                  <TablePagination
                    rowsPerPageOptions={[5, 10, 15]}
                    component="div"
                    count={filterparticipantsData.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    sx={{
                      '& .MuiTablePagination-toolbar': {
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexWrap: 'nowrap', // Ensures everything stays in one line
                        minHeight: '40px', // Keeps a proper height
                      },
                      '& .MuiTablePagination-selectLabel': {
                        marginBottom: 0, // Fixes label misalignment
                      },
                      '& .MuiTablePagination-displayedRows': {
                        marginBottom: 0, // Fixes row count misalignment
                      },
                    }}
                  />



                </TableContainer>
              </div>
            </div>
          </div>

          {isModalOpenIncome && (
            <div className="fixed inset-0 flex items-center justify-center z-10">
              <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '800px' }}>
                <div className="w-full mb-4 flex">
                  <div className="w-1/10 mr-2">

                    <label htmlFor="eventIncomeExpense">
                      Select Event Head

                    </label>
                    <Select
                      value={eventIncomeExpenseselectedOption1}
                      onChange={(option) => setEventIncomeExpenseSelectedOption(option)}
                      options={eventIncomeExpenseoptions}
                      placeholder={'Select Event Expense Head'}
                      isSearchable
                      menuPortalTarget={document.body} // Ensures dropdown renders outside its parent
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        control: (provided) => ({
                          ...provided,
                          width: "300px", // Default fixed width
                          minWidth: "200px", // Prevents shrinking smaller than this
                          maxWidth: "auto", // Expands if needed
                          cursor: "pointer",
                          whiteSpace: "nowrap"
                        }),
                        menu: (provided) => ({
                          ...provided,
                          width: "auto",
                          minWidth: "300px",
                          whiteSpace: "nowrap",
                          overflowX: "auto", // Allows horizontal scrolling if needed
                          overflowY: "hidden", // Disables vertical scrolling
                          maxHeight: "none"
                        }),

                      }}
                    />

                  </div>
                  <div className="flex items-center">
                    <input
                      type="radio"
                      id="isExpense"
                      name="entityType"
                      value="isExpense"
                      checked={isExpense}
                      onChange={() => {
                        setIncome(false);
                        setExpense(true);
                      }}
                    />
                    <label htmlFor="isExpense" className="ml-2">Expense</label>

                    <input
                      type="radio"
                      id="isincome"
                      name="entityType"
                      value="isincome"
                      checked={isincome}
                      onChange={() => {
                        setIncome(true);
                        setExpense(false);
                      }}
                      className="ml-4"
                    />
                    <label htmlFor="isincome" className="ml-2">Income</label>
                  </div>
                </div>
                <div className="w-full mb-4 flex">

                  <div className="w-1/8 mr-2">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="GSTRate">
                      Amount
                    </label>
                    <input
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                      type="text"
                      name="Amount"
                      placeholder="Enter Amount"
                      value={incomeexpenseList.Amount}
                      onChange={handleIncomeInputChange}
                    />
                  </div>
                </div>
                <div className="w-1/2 mr-4" style={{ marginTop: '23px' }}>
                  <button className="bg-green-500 text-white px-4 py-2 rounded" onClick={addIncomeRecord}>
                    Add Record
                  </button>
                  <button className="bg-blue-500 text-white px-4 py-2 rounded ml-2" onClick={toggleModalIncome}>
                    Cancel
                  </button>
                  <button className="bg-blue-500 text-white px-4 py-2 rounded ml-2" onClick={toggleModalNewHead}>
                    + Head
                  </button>

                </div>
              </div>
            </div>
          )}




          {isModalOpenNonMember && (
            <div className="fixed inset-0 flex items-center justify-center z-10">
              <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '800px' }}>
                <div className="w-full mb-4 flex">
                  <div className="w-1/10 mr-2">

                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                      Name
                    </label>
                    <input
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                      type="text"
                      name="MemberName"
                      placeholder="Enter Name"
                      value={newRecordData.MemberName}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="w-full mb-4 flex">

                  <div className="w-1/8 mr-2">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="GSTRate">
                      Relation
                    </label>
                    <input
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                      type="text"
                      name="phoneNumber"
                      placeholder="Enter Phone Number"
                      value={newRecordData.phoneNumber}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="w-1/2 mr-4" style={{ marginTop: '23px' }}>
                  <button className="bg-green-500 text-white px-4 py-2 rounded" onClick={addNonMemberRecord}>
                    Add Record
                  </button>
                  <button className="bg-blue-500 text-white px-4 py-2 rounded ml-2" onClick={toggleModalNonMember}>
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}





          {isModalOpen && (
            <div className="fixed inset-0 flex items-center justify-center z-10">
              <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '600px', height: '500px' }}>
                <div className="w-full mb-4 flex items-center justify-between">
                  {/* Select Members Label and Buttons */}
                  <div>
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Search Member
                    </label>
                    <input

                      type="text"
                      placeholder="Search Member"
                      value={searchMember}
                      onChange={handleSearchmemberChange}
                      className="search-input shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    />

                  </div>

                  {/* Buttons placed next to the label */}
                  <div className="flex">
                    <button
                      className="bg-green-500 text-white text-sm px-2 py-1 rounded-full mr-2"
                      onClick={addRecord}
                    >
                      +
                    </button>
                    <button
                      className="bg-red-500 text-white text-sm px-2 py-1 rounded-full"
                      onClick={toggleModalClose}
                    >
                      X
                    </button>
                  </div>
                </div>

                <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                  <table className="min-w-full border-collapse text-sm">
                    <thead>
                      <tr>
                        <th className="border px-2 py-1 bg-gray-200 text-xs">
                          Select
                          <input
                            type="checkbox"
                            onChange={handleSelectAllChange}
                            checked={selectAllChecked}
                            style={{ marginLeft: '-20px' }}
                          />
                        </th>
                        <th className="border px-2 py-1 bg-gray-200 text-xs">Name</th>
                        <th className="border px-2 py-1 bg-gray-200 text-xs">Phone</th>
                        <th className="border px-2 py-1 bg-gray-200 text-xs">Email</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredmembers.map(member => (
                        <tr key={member.value}>
                          <td className="border px-2 py-1 text-center">
                            <input
                              type="checkbox"
                              onChange={(event) => handleCheckboxChange(event, member.value)}
                              checked={selectedMemberlist.includes(member.value)}
                              style={{ height: '17px', textAlign: 'left', marginLeft: '-10px' }}
                            />
                          </td>
                          <td className="border px-2 py-1 text-xs">
                            {member.label}
                          </td>
                          <td className="border px-2 py-1 text-xs">
                            {member.phoneNumber}
                          </td>
                          <td className="border px-2 py-1 text-xs">
                            {member.email}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>



              </div>
            </div>
          )}

          {/* {isFamilyMemberModalOpen && (
              <div className="fixed inset-0 flex items-center justify-center z-10">
                <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '800px', height: '500px' }}>
                  <div className="w-full mb-4">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">Select Family Members</label>
                    {/* <select value={selectedMember} onChange={handleMemberSelectChange}>
                                              <option value="">Select Member</option>
                                              {memberlist.map(member => (
                                                  <option key={member.value} value={member.value}>
                                                      {member.label}
                                                  </option>
                                              ))}
                                          </select> */}
          {/*
                    <Select
                      value={memberlist.find(member => member.value === selectedMember)} // Show selected value
                      onChange={handleMemberSelectChange} // Handle selection
                      options={memberlist} // Provide options (memberlist already has the right format)

                      placeholder="Search and select member"
                      isSearchable // Makes the dropdown searchable
                    />

                    {/* Scrollable table */}
          {/*   <div className="overflow-hidden border border-gray-300 rounded">
                      <table className="min-w-full border-collapse">
                        <thead>
                          <tr>
                            <th className="border px-4 py-2 bg-gray-200">
                              <span style={{ fontWeight: 'bolder' }}>Select
                                <input type="checkbox" onChange={handleSelectAllChangeFamily} checked={selectAllChecked} style={{ marginLeft: '-55PX' }} />
                              </span>
                            </th>
                          
                            <th className="border px-4 py-2 bg-gray-200">Family Member</th>

                          </tr>
                        </thead>
                      </table>
                  
                      <div className="overflow-y-auto max-h-64" style={{ height: '350px' }}>
                        <table className="min-w-full border-collapse">
                          <tbody>
                            {familyMembers.map(member => (
                              <tr key={member.id}>
                                <td className="border px-4 py-2 text-center">
                                  <input
                                    type="checkbox"
                                    onChange={(event) => handleCheckboxChangeFamily(event, member.id)} // Use `member.value` as the family memberId
                                    checked={selectedMemberlist.includes(member.id)} // Check if this member is selected
                                    style={{ height: '17px', textAlign: 'left' }}
                                  />
                                </td>
                                <td className="border px-4 py-2">
                                  {member.name}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div className="w-1/2 mr-4" style={{ marginTop: '23px' }}>
                    <button className="bg-green-500 text-white px-4 py-2 rounded" onClick={addSelectedFamilyMembers}>
                      Add Record
                    </button>
                    <button className="bg-blue-500 text-white px-4 py-2 rounded ml-2" onClick={toggleFamilyModalClose}>
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            )} */}



          {isFamilyMemberModalOpen && (
            <div className="fixed inset-0 flex items-center justify-center z-10">
              <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '600px', height: '500px' }}>
                <div className="w-full mb-4 flex items-center justify-between">
                  {/* Select Family Members Label and Buttons */}
                  <div>
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Select Family Members
                    </label>
                  </div>

                  {/* Buttons placed next to the label */}
                  <div className="flex">
                    <button
                      className="bg-green-500 text-white text-sm px-2 py-1 rounded-full mr-2"
                      onClick={addSelectedFamilyMembers}
                    >
                      +
                    </button>
                    <button
                      className="bg-red-500 text-white text-sm px-2 py-1 rounded-full"
                      onClick={toggleFamilyModalClose}
                    >
                      X
                    </button>
                  </div>
                </div>

                {/* Family Member Select Dropdown */}
                <div className="mb-4">
                  {/* <Select
                    value={memberlist.find(member => member.value === selectedMember)} // Show selected value
                    onChange={handleMemberSelectChange} // Handle selection
                    options={memberlist} // Provide options (memberlist already has the right format)
                    placeholder="Search and select member"
                    isSearchable // Makes the dropdown searchable
                    className="w-full" // Ensures the Select component takes up full width
                    
                  /> */}

                  <input
                    type="text"
                    id="searchMember"
                    value={searchTerm} // Show selected value
                    options={memberlist}
                    onChange={handleMemberSelectChange}
                    placeholder="Type to search members"
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                  />



                  {ispersonModalOpen && (
                    <div className="fixed inset-0 flex items-center justify-center z-10">
                      <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '800px', height: '490px', overflowY: 'auto' }}>
                        <div className="flex justify-end">
                          <button onClick={closeModal} className="text-red-500 font-bold">Close</button>
                        </div>


                        <table className="mt-4 w-full border border-gray-300" style={{ borderCollapse: 'collapse', marginTop: '-10px' }}>
                          <thead sx={{ backgroundColor: '#14a3c7' }}>
                            <tr>
                              <th style={{ backgroundColor: '#f3f3f3', padding: '3px', border: '1px solid #ccc', fontSize: '12px', textTransform: 'uppercase' }}>First Name</th>
                              <th style={{ backgroundColor: '#f3f3f3', padding: '3px', border: '1px solid #ccc', fontSize: '12px', textTransform: 'uppercase' }}>Last Name</th>
                              <th style={{ backgroundColor: '#f3f3f3', padding: '3px', border: '1px solid #ccc', fontSize: '12px', textTransform: 'uppercase' }}>Phone Number</th>
                              <th style={{ backgroundColor: '#f3f3f3', padding: '3px', border: '1px solid #ccc', fontSize: '12px', textTransform: 'uppercase' }}>Email</th>
                            </tr>
                          </thead>
                          <tbody>
                            {memberlist.map((member) => (
                              <tr
                                key={member.id}
                                onClick={() => handleRowClick(member)}
                                className="cursor-pointer hover:bg-gray-200"
                                style={{ borderBottom: '1px solid #ddd' }}
                              >
                                <td style={{ padding: '3px', border: '1px solid #ccc', fontSize: '12px' }}>{member.firstName}</td>
                                <td style={{ padding: '3px', border: '1px solid #ccc', fontSize: '12px' }}>{member.lastname}</td>
                                <td style={{ padding: '3px', border: '1px solid #ccc', fontSize: '12px' }}>{member.phoneNumber}</td>
                                <td style={{ padding: '3px', border: '1px solid #ccc', fontSize: '12px' }}>{member.email}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}




                </div>

                <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                  <table className="min-w-full border-collapse text-sm">
                    <thead>
                      <tr>
                        <th className="border px-2 py-1 bg-gray-200 text-xs">
                          <span style={{ fontWeight: 'bolder' }}>Select
                            <input
                              type="checkbox"
                              onChange={handleSelectAllChangeFamily}
                              checked={selectAllChecked}
                              style={{ marginLeft: '-45px' }}
                            />
                          </span>
                        </th>
                        <th className="border px-2 py-1 bg-gray-200 text-xs">Family Member</th>
                      </tr>
                    </thead>

                    <tbody>
                      {familyMembers.map(member => (
                        <tr key={member.id}>
                          <td className="border px-2 py-1 text-center">
                            <input
                              type="checkbox"
                              onChange={(event) => handleCheckboxChangeFamily(event, member.id)} // Use `member.id` for the family memberId
                              checked={selectedMemberlist.includes(member.id)} // Check if this member is selected
                              style={{ height: '17px', textAlign: 'left' }}
                            />
                          </td>
                          <td className="border px-2 py-1 text-xs">
                            {member.name}
                          </td>

                        </tr>
                      ))}
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          )}


          {IsPaymentandReceipt && (
            <div className="fixed inset-0 flex items-center justify-center z-10">
              <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '600px', height: '500px' }}>
                <div className="w-full mb-4 flex items-center justify-between">
                  {/* Select Family Members Label and Buttons */}
                  <div>
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      PAYMENT & RECEIPT
                    </label>
                  </div>

                  {/* Buttons placed next to the label */}
                  <div className="flex">
                    <button
                      className="bg-green-500 text-white text-sm px-2 py-1 rounded-full mr-2"
                      onClick={SavePr}

                    >
                      Save
                    </button>
                    <button
                      className="bg-red-500 text-white text-sm px-2 py-1 rounded-full"
                      onClick={togglePrClose}
                    >
                      X
                    </button>
                  </div>
                </div>

                {/* Family Member Select Dropdown */}
                <div className="w-full mb-2 flex">
                  <div className="w-1/4 mr-2">
                    <label htmlFor="billNo">Bill No</label>
                    <input
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                      value={billNo}
                      onChange={(e) => setBillNo(e.target.value)}
                      type="text"
                      placeholder="Enter Bill No"
                    />
                  </div>
                  <div className="w-1/10 mr-2">
                    <label htmlFor="billDate">Bill Date</label>
                    <input
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                      value={billDate}
                      onChange={(e) => setBillDate(e.target.value)}
                      type="date"
                      placeholder="Select Bill Date"
                    />
                  </div>


                  <div className="w-1/10 mr-2">
                    <label htmlFor="amount">Amount</label>
                    <input
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                      value={amount}
                      onChange={(e) => setAmount(e.target.value)}
                      type="TEXT"
                      placeholder="Enter Amount"
                    // Submit when Enter is pressed
                    />
                  </div>

                </div>
                <div className="w-full flex flex-wrap">

                  <div className="w-full mb-4 flex">
                    <div className="w-1/10 mr-2">
                      <div className="flex items-center">
                        <input
                          type="radio"
                          id="ispayment"
                          name="entityTypeEdit"
                          value="ispayment"
                          checked={ispayment}
                          onChange={() => {
                            setIsPayment(true)
                            setEventIncomeExpenseOption("");
                            setClubIncomeExpenseOption("");
                          }}
                        />
                        <label htmlFor="onetimeEdit" className="ml-2">Payment</label>

                        <input
                          type="radio"
                          id="ispayment"
                          name="entityTypeEdit"
                          value="ispayment"
                          checked={!ispayment}
                          onChange={() => {
                            setIsPayment(false)
                            setEventIncomeExpenseOption("");
                            setClubIncomeExpenseOption("");
                          }}
                          className="ml-4"
                        />
                        <label htmlFor="ispayment" className="ml-2">Receipt</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="w-1/10 mr-2">
                  <label htmlFor="clubOptions" style={{ fontSize: '16px' }}>
                    {ispayment ? 'Select Club Expense Head' : 'Select Income Head'}
                  </label>
                  <div className="flex items-center">
                    <Select
                      value={clubIncomeExpenseOption}
                      onChange={(option) => setClubIncomeExpenseOption(option)}
                      options={ispayment ? eventheadexpenselist : eventheadincomelist}
                      placeholder={ispayment ? 'Choose an expense head' : 'Choose an income head'}
                      isSearchable
                    />
                  </div>
                </div>

                <div className="w-1/10 mr-2">
                  <label htmlFor="eventIncomeExpense">
                    {ispayment ? 'Select Event Expense' : 'Select Event Income'}
                  </label>
                  <Select
                    value={eventIncomeExpenseOption}
                    onChange={handleIncomeExpenseChange}
                    // options={ispayment ? incomeexpenseList.filter(item => !item.isIncome) : incomeexpenseList.filter(item => item.isIncome)} // Filter based on income/expense
                    options={
                      ispayment
                        ? expenseList // If it's payment (expense), use expenseList
                        : incomeList // Otherwise, use incomeList
                    }


                    placeholder={ispayment ? 'Select Event Expense' : 'Select Event Income'}
                    isSearchable
                  />
                </div>
                <div className="w-1/10 mr-2">

                  <label htmlFor="amount">Description</label>
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    value={description1}
                    onChange={(e) => setDescription1(e.target.value)}
                    type="text"
                    placeholder="Enter Description"
                  />
                </div>

                <div className="w-full flex flex-wrap" style={{ marginTop: '3px' }}>
                  {/* Payment Type Dropdown */}
                  <div className="flex items-center mb-4">
                    <label htmlFor="paymentType" className="mr-2">Payment Type</label>
                    <select
                      id="paymentType"
                      value={paymentType}
                      onChange={handlePaymentTypeChange}
                      className="mr-2"
                    >
                      <option value="0">Cash</option>
                      <option value="1">Cheque</option>
                      <option value="2">UPI</option>
                    </select>
                  </div>
                </div>

                <div className="w-full flex flex-wrap">

                  {paymentType === '1' && (
                    <div className="w-1/3 mr-2">
                      <label htmlFor="chequeNo">Cheque No</label>
                      <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        value={chequeNo}
                        onChange={(e) => setChequeNo(e.target.value)}
                        type="text"
                        placeholder="Enter Cheque No"
                      />
                    </div>
                  )}


                  {paymentType === '1' && (
                    <div className="w-1/3 mr-2">
                      <label htmlFor="chequeDate">Date</label>
                      <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        value={chequeDate}
                        onChange={(e) => setChequeDate(e.target.value)}
                        type="date"
                        placeholder="Select Date"
                      />
                    </div>
                  )}


                  {(paymentType === '1' || paymentType === '2') && (
                    <div className="w-1/3 mr-2">
                      <label htmlFor="bank">Bank</label>
                      <div className="flex items-center">
                        <Select
                          value={selectedbank}
                          onChange={handleBankChange}
                          options={banklist}
                          placeholder="Select Bank"
                          isSearchable
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}


          {incomeActualSplit && (
            <div className="fixed inset-0 flex items-center justify-center z-10">
              <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '600px', height: '500px' }}>
                <div className="w-full mb-4 flex items-center justify-between">


                  <label htmlFor="chequeNo">Income Actual Split</label>
                  <div className="flex">

                    <button
                      className="bg-red-500 text-white text-sm px-2 py-1 rounded-full"
                      onClick={toggleIncomeModalClose}
                    >
                      X
                    </button>
                  </div>
                </div>

                <div className="overflow-hidden border border-gray-300 rounded">
                  <table className="min-w-full border-collapse text-sm">
                    <thead>
                      <tr>

                        <th className="border px-2 py-1 bg-gray-200 text-xs">Bill No</th>
                        <th className="border px-2 py-1 bg-gray-200 text-xs">Bill Date</th>
                        <th className="border px-2 py-1 bg-gray-200 text-xs">Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {incomeSplitList.map(member => (
                        <tr>
                          <td className="border px-2 py-1 text-xs">
                            {member.billNo}
                          </td>
                          <td className="border px-2 py-1 text-xs">
                            {formatDateForInput(member.billDate)}

                          </td>
                          <td className="border px-2 py-1 text-xs">
                            {member.amount}
                          </td>

                        </tr>
                      ))}
                    </tbody>



                  </table>




                </div>
              </div>
            </div>
          )}


          {expenseActualSplit && (
            <div className="fixed inset-0 flex items-center justify-center z-10">
              <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '600px', height: '500px' }}>
                <div className="w-full mb-4 flex items-center justify-between">


                  <label htmlFor="chequeNo">Expense Actual Split</label>
                  <div className="flex">

                    <button
                      className="bg-red-500 text-white text-sm px-2 py-1 rounded-full"
                      onClick={toggleExpenseModalClose}
                    >
                      X
                    </button>
                  </div>
                </div>

                <div className="overflow-hidden border border-gray-300 rounded">
                  <table className="min-w-full border-collapse text-sm">
                    <thead>
                      <tr>

                        <th className="border px-2 py-1 bg-gray-200 text-xs">Bill No</th>
                        <th className="border px-2 py-1 bg-gray-200 text-xs">Bill Date</th>
                        <th className="border px-2 py-1 bg-gray-200 text-xs">Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {expenseSplitList.map(member => (
                        <tr>
                          <td className="border px-2 py-1 text-xs">
                            {member.billNo}
                          </td>
                          <td className="border px-2 py-1 text-xs">
                            {formatDateForInput(member.billDate)}

                          </td>
                          <td className="border px-2 py-1 text-xs">
                            {member.amount}
                          </td>

                        </tr>
                      ))}
                    </tbody>



                  </table>




                </div>
              </div>
            </div>
          )}


          {isModalOpenCreateHead && (
            <div className="fixed inset-0 flex items-center justify-center z-10">
              <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '80%' }}>
                <h6 style={{ color: 'black', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', textAlign: 'center' }}>CREATE ACCOUNT HEAD </h6>
                <div className="w-full mb-4 flex">

                </div>

                <div className="w-full mb-4 flex">

                  <div className="w-1/4 mr-2">
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="feesDescription">Account Head</label>
                    <input
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                      value={head}
                      onChange={(e) => setAccountHead(e.target.value)}
                      type="text"
                      placeholder="Enter Account Head"
                    />
                  </div>
                  <div className="w-1/6 mr-2">


                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="Currency"> Currency</label>
                    <input
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                      value={currency}
                      onChange={(e) => setCurrency(e.target.value)}
                      type="text"
                      placeholder="Enter Currency"
                    />
                  </div>


                  <div className="w-1/4 mr-2">
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="parentgroup">Nature</label>
                    <Select
                      options={natureOptions}
                      value={nature}
                      onChange={handleChange1}
                      isSearchable
                      menuPortalTarget={document.body} // Ensures dropdown renders outside its parent
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        control: (provided) => ({
                          ...provided,
                          width: "100%",
                          minWidth: 0, // allow shrinking
                          whiteSpace: "nowrap"
                        }),
                        menu: (provided) => ({
                          ...provided,
                          width: "100%",
                          minWidth: "200px",
                          whiteSpace: "nowrap",
                          overflowX: "auto", // Allows horizontal scrolling if needed
                          overflowY: "hidden", // Disables vertical scrolling
                          maxHeight: "none"
                        }),

                      }}
                    />
                  </div>
                  <div className="w-1/4 mr-2">
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="Currency"> Parent Group</label>
                    <input
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                      value={parent}
                      //onChange={(e) => setParent(e.target.value)}
                      type="text"
                      placeholder="Parent Group"
                    />
                  </div>

                </div>
                <div className="w-full mb-4 flex">
                  <div className="w-1/4 mr-2">
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="opening">Opening Bal Amt</label>
                    <input
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                      value={opening}
                      onChange={(e) => setOpening(e.target.value)}
                      type="text"
                      placeholder="Enter Opening"
                    />
                  </div>
                  <div className="w-1/4 mr-2">
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="opening">Opening Bal Polarity</label>

                    <Select
                      options={optionsp}
                      value={selectedpolarity} // Important: Bind the value
                      onChange={handleChange2}
                    />
                  </div>
                  <div className="w-1/4 mr-2">
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="opening">Opening Bal Date</label>
                    <input
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                      value={openingdate}
                      onChange={(e) => setOpeningDate(e.target.value)}
                      type="date"
                      placeholder="Select Date"
                    />
                  </div>


                </div>




                {/* Action Buttons */}
                <div className="w-1/2 mr-4" style={{ marginTop: '23px' }}>
                  <Button onClick={handleFormSubmit1} style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#5DB996' }}>
                    Save
                  </Button>
                  <Button style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#FF748B', marginLeft: '5px' }} onClick={toggleModalCloseHead}>
                    Cancel
                  </Button>
                </div>
              </div>
            </div>
          )}




        </div>

      </div >


    </Fragment >
  );



};

export default EventEdit;
